import React from "react";

import { Box, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";
import { NCIcon } from "@components/Icons/Icon";

const useStyles = makeStyles()({
  description: {
    fontSize: 14,
    color: colors.grey,
    marginTop: 1,
  },
  kcal: {
    marginTop: 5,
    fontSize: 14,
    fontWeight: 700,
    color: colors.dark,
  },
  kcalLabel: {
    fontFamily: "Mulish",
    fontWeight: 600,
    color: colors.grey,
  },
});

interface Props {
  icon: any;
  name: string;
  description: string;
  kcal: number | null;
  nokcalLabel?: boolean;
}

const CalListItem: React.FC<Props> = ({
  icon,
  name,
  description,
  kcal,
  nokcalLabel = false,
}) => {
  const { classes } = useStyles();
  return (
    <Box flex={1}>
      <Box display="flex">
        <NCIcon icon={icon} htmlColor={colors.grey} mr="normal" />
        <Box display="flex" flexDirection="column">
          <Typography variant="body1">{name}</Typography>
          <Typography className={classes.description}>{description}</Typography>
          <Typography className={classes.kcal}>
            {kcal ?? "--"}
            {!nokcalLabel && (
              <span className={classes.kcalLabel}> kcal/day</span>
            )}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default CalListItem;
